import { FlexLayout as FoundationFlexLayout, foundationFlexLayoutTemplate as zeroFlexLayoutTemplate, foundationFlexLayoutStyles as zeroFlexLayoutStyles, foundationFlexLayoutShadowOptions as zeroFlexLayoutShadowOptions, defaultFlexLayoutConfig, } from '@genesislcap/foundation-ui';
/**
 * @tagname %%prefix%%-flex-layout
 */
export class FlexLayout extends FoundationFlexLayout {
}
/**
 * The Zero Flex Layout
 *
 * @public
 * @remarks
 * HTML Element: \<zero-flex-layout\>
 */
export const zeroFlexLayout = FlexLayout.compose(Object.assign({ baseName: 'flex-layout', shadowOptions: zeroFlexLayoutShadowOptions, styles: zeroFlexLayoutStyles, template: zeroFlexLayoutTemplate }, defaultFlexLayoutConfig));
